import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;
const evaluation_category_questionnaire_endpoint =
  "EvaluationCategoryQuestionnaireController";
const evaluation_fiche_endpoint = "EvaluationFicheController";
const evaluation_jalon_endpoint = "EvaluationJalonController";
const evaluation_questionnaire_endpoint = "EvaluationQuestionnaireController";
const evaluation_reponse_endpoint = "EvaluationReponseController";
const evaluation_saison_endpoint = "EvaluationSaisonController";
const evaluation_type_questionnaire_endpoint =
  "EvaluationTypeQuestionnaireController";
const evaluation_type_reponse_endpoint = "EvaluationTypeReponseController";
const service_endpoint = "Service";
const evaluation_quesiton_par_fiche_endpoint =
  "EvaluationQuestionnaireParFicheController";
const createEvaluationApiError = (error, fallbackMessage) => {
  const apiError = new Error(
    error.response?.data?.message || error.message || fallbackMessage,
  );
  apiError.errorCode = error.response?.data?.errorCode || null;
  apiError.status = error.response?.status || null;
  return apiError;
};

export const evaluation_refonte_saison_service = {
  async downloadFicheEvaluation(
    id_candidat,
    id_saison,
    type_evaluation = 1,
    id_evaluateur = null,
    file_name = "Fiche d'evaluation.pdf",
  ) {
    try {
      const response = await axios.get(
        apiUrl + "/" + evaluation_fiche_endpoint + `/export_fiche_en_pdf/`,
        {
          params: {
            id_candidat: id_candidat,
            id_saison: id_saison,
            type_evaluation: type_evaluation,
            id_evaluateur: id_evaluateur,
          },
          responseType: "blob",
        },
      );
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" }),
      );

      // Créer un lien de téléchargement
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Fiche EP de " + file_name);
      document.body.appendChild(link);
      link.click();

      // Nettoyage
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "Erreur lors du téléchargement de la fiche";
      throw new Error(message);
    }
  },
  async getList(filtre) {
    try {
      const result = await axios.get(
        apiUrl + "/" + evaluation_saison_endpoint + `/list/`,
        {
          params: filtre,
        },
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },

  async getResultList(filtre) {
    try {
      const result = await axios.get(
        apiUrl + "/" + evaluation_saison_endpoint + `/resultat/`,
        {
          params: filtre,
        },
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getOne(id) {
    try {
      const result = await axios.get(
        apiUrl + "/" + evaluation_saison_endpoint + `/find/`,
        {
          params: { id_objet: id },
        },
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getActiveOne() {
    try {
      const result = await axios.get(
        apiUrl + "/" + evaluation_saison_endpoint + `/find_active_one/`,
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async insert(obj) {
    try {
      const result = await axios.post(
        apiUrl + "/" + evaluation_saison_endpoint + `/insert/`,
        obj,
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async update(obj) {
    try {
      const result = await axios.post(
        apiUrl + "/" + evaluation_saison_endpoint + `/update/`,
        obj,
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async delete(obj) {
    try {
      const result = await axios.post(
        apiUrl + "/" + evaluation_saison_endpoint + `/delete/`,
        obj,
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
};
export const evaluation_refonte_fiche_evaluation_service = {
  async getList(filtre) {
    try {
      const result = await axios.get(
        apiUrl + "/" + evaluation_fiche_endpoint + `/list/`,
        {
          params: filtre,
        },
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getOne(id) {
    try {
      const result = await axios.get(
        apiUrl + "/" + evaluation_fiche_endpoint + `/find/`,
        {
          params: { id_objet: id },
        },
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getAllDetail(id) {
    try {
      const result = await axios.get(
        apiUrl + "/" + evaluation_fiche_endpoint + `/find_all_detail/`,
        {
          params: { obj_id: id },
        },
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getAllDetailByUserId(id, evaluateur_id) {
    try {
      const result = await axios.get(
        apiUrl +
          "/" +
          evaluation_fiche_endpoint +
          `/detail_fiche_evaluation_by_user_id/`,
        {
          params: { obj_id: id, evaluateur_id: evaluateur_id },
        },
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
      throw error;
    }
  },
  async getEvaluationPreviewDetails(id, evaluateurId, saisonId) {
    try {
      const result = await axios.get(
        apiUrl +
          "/" +
          evaluation_fiche_endpoint +
          `/evaluation_preview_detail/`,
        {
          params: {
            obj_id: id,
            evaluateur_id: evaluateurId,
            id_saison: saisonId,
          },
        },
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
      throw error;
    }
  },
  async insert(obj) {
    try {
      const result = await axios.post(
        apiUrl + "/" + evaluation_fiche_endpoint + `/insert/`,
        obj,
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
      throw error;
    }
  },
  async insertThenAssignToFiche(obj) {
    try {
      const result = await axios.post(
        apiUrl +
          "/" +
          evaluation_fiche_endpoint +
          `/insert_then_assign_to_fiche/`,
        obj,
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async update(obj) {
    try {
      const result = await axios.post(
        apiUrl + "/" + evaluation_fiche_endpoint + `/update/`,
        obj,
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async delete(obj) {
    try {
      const result = await axios.post(
        apiUrl + "/" + evaluation_fiche_endpoint + `/delete/`,
        obj,
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
};
export const evaluation_refonte_category_service = {
  async getList(filtre) {
    try {
      const result = await axios.get(
        apiUrl + "/" + evaluation_category_questionnaire_endpoint + `/list/`,
        {
          params: filtre,
        },
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },

  async getOne(id) {
    try {
      const result = await axios.get(
        apiUrl + "/" + evaluation_category_questionnaire_endpoint + `/find/`,
        {
          params: { id_objet: id },
        },
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async insert(obj) {
    try {
      const result = await axios.post(
        apiUrl + "/" + evaluation_category_questionnaire_endpoint + `/insert/`,
        obj,
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async update(obj) {
    try {
      const result = await axios.post(
        apiUrl + "/" + evaluation_category_questionnaire_endpoint + `/update/`,
        obj,
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async delete(obj) {
    try {
      const result = await axios.post(
        apiUrl + "/" + evaluation_category_questionnaire_endpoint + `/delete/`,
        obj,
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
};
export const evaluation_utilitises_service = {
  async getServiceList(id_direction) {
    try {
      const result = await axios.get(
        apiUrl + "/Service/getServiceByIdDirection/" + id_direction,
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getStats(filtre) {
    try {
      const result = await axios.get(
        apiUrl + "/" + evaluation_saison_endpoint + `/getStats/`,
        {
          params: filtre,
        },
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async exportexcel(filtre) {
    try {
      const result = await axios.get(
        apiUrl + "/EvaluationSaisonController/modeleexport/",
        {
          params: filtre,
          responseType: "blob",
          headers: {
            Accept:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
        },
      );
      return result;
    } catch (error) {
      console.error("Erreur d'export:", error);
      if (error.response) {
        return error.response;
      }
      throw error;
    }
  },
};
export const evaluation_refonte_type_questionnaire_service = {
  async getList(filtre) {
    try {
      const result = await axios.get(
        apiUrl + "/" + evaluation_type_questionnaire_endpoint + `/list/`,
        {
          params: filtre,
        },
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getOne(id) {
    try {
      const result = await axios.get(
        apiUrl + "/" + evaluation_type_questionnaire_endpoint + `/find/`,
        {
          params: { id_objet: id },
        },
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async insert(obj) {
    try {
      const result = await axios.post(
        apiUrl + "/" + evaluation_type_questionnaire_endpoint + `/insert/`,
        obj,
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async update(obj) {
    try {
      const result = await axios.post(
        apiUrl + "/" + evaluation_type_questionnaire_endpoint + `/update/`,
        obj,
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async delete(obj) {
    try {
      const result = await axios.post(
        apiUrl + "/" + evaluation_type_questionnaire_endpoint + `/delete/`,
        obj,
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
};
export const evaluation_refonte_jalon_service = {
  async getList(filtre) {
    try {
      const result = await axios.get(
        apiUrl + "/" + evaluation_jalon_endpoint + `/list/`,
        {
          params: filtre,
        },
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getListByFiche(filtre) {
    try {
      const result = await axios.get(
        apiUrl + "/" + evaluation_jalon_endpoint + `/list_by_fiche/`,
        { params: { filtre: filtre } },
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getOne(id) {
    try {
      const result = await axios.get(
        apiUrl + "/" + evaluation_jalon_endpoint + `/find/`,
        {
          params: { id_objet: id },
        },
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async insert(obj) {
    try {
      const result = await axios.post(
        apiUrl + "/" + evaluation_jalon_endpoint + `/insert/`,
        obj,
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async update(obj) {
    try {
      const result = await axios.post(
        apiUrl + "/" + evaluation_jalon_endpoint + `/update/`,
        obj,
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async delete(obj) {
    try {
      const result = await axios.post(
        apiUrl + "/" + evaluation_jalon_endpoint + `/delete/`,
        obj,
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
};
export const evaluation_refonte_questionnaire_service = {
  async getList(filtre) {
    try {
      const result = await axios.get(
        apiUrl + "/" + evaluation_questionnaire_endpoint + `/list/`,
        {
          params: filtre,
        },
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getListByFiche(filtre) {
    try {
      const result = await axios.get(
        apiUrl + "/" + evaluation_questionnaire_endpoint + `/list_by_fiche/`,
        {
          params: filtre,
        },
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getOne(id) {
    try {
      const result = await axios.get(
        apiUrl + "/" + evaluation_questionnaire_endpoint + `/find/`,
        {
          params: { id_objet: id },
        },
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async insert(obj) {
    try {
      const result = await axios.post(
        apiUrl + "/" + evaluation_questionnaire_endpoint + `/insert/`,
        obj,
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async update(obj) {
    try {
      const result = await axios.post(
        apiUrl + "/" + evaluation_questionnaire_endpoint + `/update/`,
        obj,
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async delete(obj) {
    try {
      const result = await axios.post(
        apiUrl + "/" + evaluation_questionnaire_endpoint + `/delete/`,
        obj,
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
};
export const evaluation_refonte_reponse_service = {
  async getList(filtre) {
    try {
      const result = await axios.get(
        apiUrl + "/" + evaluation_reponse_endpoint + `/list/`,
        {
          params: filtre,
        },
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getEvaluateurByIdCandidatAndIdSession(id_candidat, id_session,inclure_moi=true) {
    try {
      const url = `${apiUrl}/${evaluation_reponse_endpoint}/candidature_evaluateur/?id_candidat=${encodeURIComponent(
        id_candidat,
      )}&id_session=${encodeURIComponent(id_session)}&inclure_moi=${encodeURIComponent(inclure_moi)}`;
      const result = await axios.get(url);
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
      throw error;
    }
  },
  async getLastEvaluationPreview(id_candidat, signal) {
    const result = await axios.get(
      `${apiUrl}/${evaluation_reponse_endpoint}/last_evaluation_preview/`,
      { params: { id_candidat }, signal },
    );
    if (!result.data?.success) throw new Error(result.data?.message || "Impossible de charger l'évaluation.");
    return result.data.data;
  },
  async duplicateLastEvaluation(id_candidat, id_saison, source_version) {
    try {
      const result = await axios.post(
        apiUrl + "/" + evaluation_reponse_endpoint + `/duplicate_last_evaluation/`,
        { id_candidat, id_saison, source_version },
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getInterviewCommentState(signal) {
    try {
      const response = await axios.get(
        apiUrl +
          "/" +
          evaluation_reponse_endpoint +
          "/interview_comment_state/",
        { signal },
      );
      if (!response.data?.success) {
        throw new Error(
          response.data?.message || "Impossible de charger le commentaire.",
        );
      }
      return response.data.data;
    } catch (error) {
      throw createEvaluationApiError(
        error,
        "Impossible de charger le commentaire.",
      );
    }
  },
  async updateInterviewComment(value) {
    try {
      const response = await axios.post(
        apiUrl + "/" + evaluation_reponse_endpoint + "/update_commentaire/",
        { REPONSE: value },
      );
      if (!response.data?.success) {
        throw new Error(
          response.data?.message || "Impossible d’enregistrer le commentaire.",
        );
      }
      return response.data;
    } catch (error) {
      throw createEvaluationApiError(
        error,
        "Impossible d’enregistrer le commentaire.",
      );
    }
  },
  async getCommentaireAutoEvaluationTerminierParActiveSaison(id_candidat) {
    try {
      const result = await axios.get(
        apiUrl +
          "/" +
          evaluation_reponse_endpoint +
          `/reponse_commentaire_autoevaluation_avec_active_saison/`,
        { params: { id_candidat: id_candidat } },
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getOne(id) {
    try {
      const result = await axios.get(
        apiUrl + "/" + evaluation_reponse_endpoint + `/find/`,
        {
          params: { id_objet: id },
        },
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async insert(obj) {
    try {
      const result = await axios.post(
        apiUrl + "/" + evaluation_reponse_endpoint + `/insert/`,
        obj,
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async insert_or_update(objs) {
    try {
      const result = await axios.post(
        apiUrl + "/" + evaluation_reponse_endpoint + `/insert_or_update/`,
        objs,
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async update(obj) {
    try {
      const result = await axios.post(
        apiUrl + "/" + evaluation_reponse_endpoint + `/update/`,
        obj,
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async updateCommentaire(obj) {
    try {
      const result = await axios.post(
        apiUrl + "/" + evaluation_reponse_endpoint + `/update_commentaire/`,
        obj,
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async delete(obj) {
    try {
      const result = await axios.post(
        apiUrl + "/" + evaluation_reponse_endpoint + `/delete/`,
        obj,
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
};
export const evaluation_refonte_questionnaire_par_fiche_service = {
  async getList(filtre) {
    try {
      const result = await axios.get(
        apiUrl + "/" + evaluation_quesiton_par_fiche_endpoint + `/list/`,
        {
          params: filtre,
        },
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getQuestionnaireListPerFiche(filtre) {
    try {
      const result = await axios.get(
        apiUrl + "/" + evaluation_quesiton_par_fiche_endpoint + `/list/`,
        {
          params: filtre,
        },
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getListByQuestionnaireId(questionnaire_id) {
    try {
      const result = await axios.get(
        apiUrl +
          "/" +
          evaluation_quesiton_par_fiche_endpoint +
          `/list_by_question_id/`,
        {
          params: { questionnaire_id: questionnaire_id },
        },
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getOne(id) {
    try {
      const result = await axios.get(
        apiUrl + "/" + evaluation_quesiton_par_fiche_endpoint + `/find/`,
        {
          params: { id_objet: id },
        },
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async insert(obj) {
    try {
      const result = await axios.post(
        apiUrl + "/" + evaluation_quesiton_par_fiche_endpoint + `/insert/`,
        obj,
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async insert_or_delete(fiche_id, objs) {
    try {
      const result = await axios.post(
        apiUrl +
          "/" +
          evaluation_quesiton_par_fiche_endpoint +
          `/insert_suppression_groupe/`,
        {
          params: {
            id_fiche: fiche_id,
            objs: objs,
          },
        },
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async insert_or_update(objs) {
    try {
      const result = await axios.post(
        apiUrl +
          "/" +
          evaluation_quesiton_par_fiche_endpoint +
          `/insert_or_update/`,
        objs,
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async update(obj) {
    try {
      const result = await axios.post(
        apiUrl + "/" + evaluation_quesiton_par_fiche_endpoint + `/update/`,
        obj,
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async delete(obj) {
    try {
      const result = await axios.post(
        apiUrl + "/" + evaluation_quesiton_par_fiche_endpoint + `/delete/`,
        {
          params: { id_quesiton: obj },
        },
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
};
